import { render, staticRenderFns } from "./MaterialReplace.vue?vue&type=template&id=1e778800&scoped=true"
import script from "./MaterialReplace.vue?vue&type=script&lang=js"
export * from "./MaterialReplace.vue?vue&type=script&lang=js"
import style0 from "./MaterialReplace.vue?vue&type=style&index=0&id=1e778800&prod&lang=scss"
import style1 from "./MaterialReplace.vue?vue&type=style&index=1&id=1e778800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e778800",
  null
  
)

export default component.exports